import React from "react";
import Branch from "./branchWrapper/Branch";
import { Query } from "react-apollo";
import { getBranchs } from "../../graphql/query/branch";
import AntSpin from "../common/AntSpin";
import Exception500 from "../common/exception/500";

export default function BranchWrapper({history, REMOVE_BRANCH}){
    return(
        <Query 
            query={getBranchs}
        >
            {({ loading, error, refetch, data }) => {
                if(error){
                    return <Exception500/>
                }else{
                    switch(loading ){
                        case true:
                            return <AntSpin marginTop="10%"/> 
                        case false:
                            let props = {
                                branchs: data.branchs,
                                history,
                                refetch,
                                REMOVE_BRANCH,
                            };
        
                            return <Branch props={props}/>
                        default:
                            return null
                    }    
                }
            }}
        </Query>
    )
}


// WEBPACK FOOTER //
// ./src/components/general/BranchWrapper.jsx